// Hook to set page titles
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTitle = (title: string) => {
  const location = useLocation();

  useEffect(() => {
    document.title = `${title} | Proyas`;
  }, [location, title]);
};

export default usePageTitle;
